import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";
import { SITE } from "@/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy text-slate-300">
    <div className="mx-auto max-w-6xl px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
      <div>
        <Logo dark />
        <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-xs">
          Dr. Dixit is a reputed and well-known Gastroenterologist &amp; Liver
          Specialist — DM (Gastroenterology), IMS BHU. Serving Lanka,
          Sunderpur, BHU and all of Purvanchal.
        </p>
      </div>
      <div>
        <h3 className="font-heading text-sm font-semibold uppercase tracking-[0.16em] text-sky-300">
          Visit
        </h3>
        <p className="mt-4 flex gap-2.5 text-sm leading-relaxed text-slate-300">
          <MapPin size={16} className="mt-0.5 shrink-0 text-sky-400" />
          {SITE.address}
        </p>
        <p className="mt-3 text-sm text-slate-400">
          {SITE.hours} · Consultations by prior appointment.
        </p>
      </div>
      <div>
        <h3 className="font-heading text-sm font-semibold uppercase tracking-[0.16em] text-sky-300">
          Book
        </h3>
        <a
          href={SITE.phoneHref}
          data-testid="footer-call-link"
          className="mt-4 flex items-center gap-2.5 font-heading text-xl font-bold text-white transition-colors hover:text-sky-300"
        >
          <Phone size={18} className="text-sky-400" />
          {SITE.phoneDisplay}
        </a>
        <div className="mt-5 flex gap-5 text-sm">
          <Link to="/treatments" data-testid="footer-treatments-link" className="transition-colors hover:text-sky-300">
            Treatments
          </Link>
          <Link to="/contact" data-testid="footer-contact-link" className="transition-colors hover:text-sky-300">
            Contact
          </Link>
          <a
            href={SITE.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-directions-link"
            className="transition-colors hover:text-sky-300"
          >
            Directions
          </a>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto max-w-6xl px-5 sm:px-8 py-5 text-xs text-slate-500">
        © {new Date().getFullYear()} Dr. Dixit — Gastro &amp; Liver Care, Varanasi. All rights reserved.
      </div>
    </div>
  </footer>
);
